import { combineReducers } from '@reduxjs/toolkit';
import user from './userSlice';
import country from './countrySlice';
import { auditLogReducer as auditLog } from '@ameroservices-platform/shared/ui-components/AuditLog';

const sharedReducers = combineReducers({
	auditLog,
	country,
	user,
});

export default sharedReducers;
